import axios from "axios";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import ApiEncrypt from "./apiEncrypted";

export const createInvoice = async (type, data) => {
  let keyData = {};

  keyData.apiKey = process.env.REACT_APP_APPGREGATOR_XENDIT_APIKEY_STAGE;
  keyData.connectionName =process.env.REACT_APP_APPGREGATOR_XENDIT_CONNECTION_NAME_STAGE;
  keyData.projectName =process.env.REACT_APP_APPGREGATOR_XENDIT_PROJECT_NAME_STAGE;

  if (keyData === null) {
    return {
      error: "Xendit API Key is not set",
    };
  } else {
    const apiKey = ApiEncrypt(keyData.apiKey, process.env.REACT_APP_APPGREGATOR_SECRET_KEY);


    const configurationObject = {
      url: `${process.env.REACT_APP_APPGREGATOR_XENDIT_PAYMENTSTATUS_STAGE}/invoices?name=${keyData.projectName}&connection_name=${keyData.connectionName}`,
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiKey,
      },
    };

    try {
      const response = await axios.post(configurationObject.url, data, {
        headers: configurationObject.headers,
      });
      return response.data;
    } catch (error) {
      return error.response;
    }
  }
};
